// popup content height
export function popupHeight() {
  const windowWidth = window.innerWidth;
  const popups = document.querySelectorAll(".overlay_popup");

  popups.forEach(function (popup) {
    if (popup.classList.contains("filter_popup") && windowWidth <= 768) {
      popup.style.height = ""; // height 초기화
      popup.style.maxHeight = "100dvh"; // 최대 높이 설정
      return;
    }

    const headerHeight = popup.querySelector(".popup_title").offsetHeight;
    const footer = popup.querySelector(".popup_footer");
    const footerHeight = footer.offsetHeight;
    const popupCnt = popup.querySelector(".popup_content");

    if (windowWidth <= 768) {
      const calculatedHeight = `calc(100dvh - (${headerHeight}px + ${footerHeight}px))`;
      popupCnt.style.height = calculatedHeight;
      popupCnt.style.maxHeight = "";
    } else {
      const calculatedHeight = `calc(100dvh - (${headerHeight}px + ${footerHeight}px + 196px))`;
      popupCnt.style.maxHeight = calculatedHeight;
    }

    const all = document.querySelectorAll(".popup_content > *");
    const scrollCnt = document.querySelector(".scroll_cnt");
    let totalHeightExcludingScrollCnt = 0;

    for (const child of all) {
      if (!child.classList.contains("scroll_cnt")) {
        const childHeight = parseFloat(window.getComputedStyle(child).height);
        totalHeightExcludingScrollCnt += childHeight;
      }
    }

    if (scrollCnt) {
      const scrollCntHeight = scrollCnt.offsetHeight;

      if (windowWidth <= 768) {
        const calculatedHeight = `calc(100dvh - (${headerHeight}px + ${footerHeight}px + ${totalHeightExcludingScrollCnt}px - ${scrollCntHeight}px))`;
        scrollCnt.style.height = calculatedHeight;
        scrollCnt.style.maxHeight = "";
      } else {
        const calculatedHeight = `calc(100dvh - (${headerHeight}px + ${footerHeight}px + ${totalHeightExcludingScrollCnt}px + 196px - ${scrollCntHeight}px))`;
        scrollCnt.style.maxHeight = calculatedHeight;
      }
    }
  });
}

export function resizePopup() {
  window.addEventListener("resize", function () {
    popupHeight();
  });
}
